export default __webpack_public_path__ + "static/media/virtualSports.718f33a6.svg";